module.exports = __webpack_public_path__ + "img/television1.f674aba4.png";